import React from 'react';

const Intro = ({ setShowDropdown }) => {
  return (
    <section className="about-one section-padding">
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-5">
            <div className="service-content mt-4 mt-lg-0">
              <h2 className="mb-4">
                Empowering Your Financial Journey with Trusted Investment Solutions
              </h2>
              <p>
                Explore Mutual Funds, Loans, Bonds, and Global Access – All in One Platform.
              </p>
              <a href="https://gpsfinvest.investwell.app/app/#/login" className="btn btn-primary my-4">Start Investing</a>&nbsp;&nbsp;&nbsp;
              <a
                href="#"
                className="btn btn-primary my-4"
                onClick={(e) => {
                  e.preventDefault();
                  setShowDropdown(true);
                }}
              >
                Explore Services
              </a>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="service-img">
              <img src="images/dashbordd.jpg" alt="About Us" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
